import DocumentationPage from './DocumentationPage';

export default DocumentationPage; 